<div class="modal-backdrop">
  <div class="modal-box">
    <h3>Redirect Confirmation</h3>
    <p>
      Schemes/Benefits on Maharashtra RAMP Portal are available only for Maharashtra MSMEs.
      If you would like to explore the Maharashtra RAMP portal, please click OK to proceed.
    </p>

    <div class="modal-actions">
      <button class="btn btn-primary" (click)="redirect()">Yes</button>
      <button class="btn btn-secondary" (click)="cancel()">No</button>
    </div>
  </div>
</div>
